const ALLOWED_ROLES = new Set(["admin", "staff", "owner", "viewer"]);

export function isAccessAllowed(role, active) {
  return active === true && ALLOWED_ROLES.has(String(role || "").toLowerCase());
}
